import { Signal } from '@angular/core';
// import { HashMap } from '@jsverse/transloco';
import { HashMap } from '../models/hashmap';
import { Observable } from 'rxjs';
import { TranslateEvents } from '../models/events';
import { Translation } from '../models/translation';
import { TranslationConfig } from 'i18n';

// export interface TranslateService {
//   translate(key: string, params?: HashMap, lang?: string, scope?: string): string;
//   translateAsync(key: string, params?: HashMap, lang?: string, scope?: string): Observable<string>;
//   translateSignal(key: string | string[], params?: HashMap, lang?: string, scope?: string): Signal<string | string[]>;
//   translateObjectSignal(key: string, params?: HashMap, lang?: string, scope?: string): Signal<Record<string, any>>;
//   setActiveLang(lang: string): void;
//   getActiveLang(): string;
//   activeLang: Signal<string>;
//   getAvailableLangs(): string[];
//   availableLangs: Signal<string[]>;
//   langChanges: Observable<string>;
// }

// export const TRANSLATION_SERVICE = new InjectionToken<TranslateService>('TRANSLATION_SERVICE');

export abstract class TranslateService {
  abstract load(lang: string): Observable<Translation>;
  abstract translate(key: string, params?: HashMap, lang?: string, scope?: string): string;
  abstract translateAsync(key: string, params?: HashMap, lang?: string, scope?: string): Observable<string>;
  abstract translateSignal(key: string | string[], params?: HashMap, lang?: string, scope?: string): Signal<string | string[]>;
  abstract translateObjectSignal(key: string, params?: HashMap, lang?: string, scope?: string): Signal<Translation>;
  abstract selectTranslation(lang?: string, scope?: string): Observable<Translation>;
  abstract setActiveLang(lang: string): void;
  abstract getActiveLang(): string;
  abstract setDefaultLang(lang: string): void;
  abstract getDefaultLang(): string;
  // abstract activeLang: Signal<string>;
  abstract setAvailableLangs(langs: string[]): void;
  abstract getAvailableLangs(): string[];
  // abstract availableLangs: Signal<string[]>;
  abstract langChanges: Observable<string>;
  abstract events: Observable<TranslateEvents>;
}